const investmentTypeDomainLang = {
	real_estate: {
		tag: 'investment.type.domain.real_estate',
		fr: 'Immobilier',
		en: 'Real estate',
	},
	energy_transition: {
		tag: 'investment.type.domain.energy_transition',
		fr: 'Transition énergétique',
		en: 'Energy transition',
	},
	public: {
		tag: 'investment.type.domain.public',
		fr: 'Secteur Public',
		en: 'Public Sector',
	},
	granular: {
		tag: 'investment.type.domain.granular',
		fr: 'Granulaire',
		en: 'Granual Debt',
	},
	companies: {
		tag: 'investment.type.domain.companies',
		fr: 'Entreprises',
		en: 'Corporate',
	},
	multi_management: {
		tag: 'investment.type.domain.multi_management',
		fr: 'Multigestion',
		en: 'Multi Management',
	},
	recovery_french_bond: {
		tag: 'investment.type.domain.recovery_french_bond',
		fr: 'Obligations relance',
		en: 'Recovery french bond',
	},
};

export default investmentTypeDomainLang;
